import { z } from "zod";

export const RequestParameterDtoSchema = z.object({
    requestTypeParameterId: z.string(),
    paramValue: z.any().nullish(),
    name: z.string().nullish(),
    parameterText: z.string().nullish(),
    key: z.string().nullish(),
    description: z.string().nullish(),
});

export type RequestParameterDto = z.infer<typeof RequestParameterDtoSchema>;